
import {
  createSession,
  saveSnapshot,
  setActiveSession,
  setMultiEnabled,
} from './salesSessionsSlice'
import { hydrateSlices } from './hydrateSlice'

import {
  setAppLoadingState,
  setIsAgentNoteOpen,
  setNotesSection,
  setOrderType,
} from './settingsSlice'

import rootReducer from './rootReducer'
import { handleNewArgs } from './embeddedSlice'

import { setEmbeddedShowNewCase } from './embeddedSlice'

const SNAP_KEYS = ['customer', 'settings', 'validation', 'embedded']

export const clone = (o) =>
(typeof structuredClone === 'function'
  ? structuredClone(o)
  : JSON.parse(JSON.stringify(o)))

export const takeSnapshot = (state) =>
  SNAP_KEYS.reduce((acc, k) => {
    acc[k] = clone(state[k])
    return acc
  }, {})


export const resetCustomerForNewCase = (cust, { program, caseId, initialCustomer, preserve = {} }) => {
  const base = initialCustomer ?? rootReducer(undefined, { type: '@@INIT' }).customer
  const next = clone(base)
  next.data = { ...(next.data || {}), program, caseId, ...preserve }
  return next
}

export const enableMexicoMode = (program) => (dispatch, getState) => {
  const state = getState()

  const normalizedProgram = (program ?? state.customer?.data?.program ?? '').toLowerCase()
  const casesCount = state.chatInbox?.order?.length ?? 0
  const cur = state.salesSessions.enabled

  const shouldEnable = normalizedProgram === 'mexico' && casesCount > 0

  const next = cur ? casesCount > 0 : shouldEnable

  if (cur !== next) dispatch(setMultiEnabled(next))
}


export const ensureActiveCaseSession = (targetCaseId) => (dispatch, getState) => {
  const state = getState();
  const { activeId, byId = {} } = state.salesSessions || {};

  const newCaseId = targetCaseId ?? state.customer?.data?.caseId;
  if (!newCaseId) return;

  const existing = Object.values(byId).find(
    s => s?.snapshot?.customer?.data?.caseId === newCaseId);
  if (existing) {
    if (existing.id !== activeId) dispatch(setActiveSession(existing.id));
    return;
  }


  const sessionId =
    (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2);

  const title = `Case ${String(newCaseId).slice(-6)}`;

  dispatch(createSession({ id: sessionId, title, caseId: newCaseId }));
  dispatch(setActiveSession(sessionId));
  dispatch(switchToSaleSession(sessionId))
};


export  const resetSlicesForNewCase = ({ preserveProgram = true } = {}, newArgs) =>
  async (dispatch, getState) => {
    const state = getState()
    
    dispatch(setAppLoadingState('pending'));
    
    const { activeId, byId = {} } = state.salesSessions || {}
    if (activeId && byId[activeId]) {
      const snap = {
        customer: clone(state.customer),
        settings: clone(state.settings),
        validation: clone(state.validation),
        embedded: clone(state.embedded),
      }
      dispatch(saveSnapshot({ id: activeId, snapshot: snap }))
    }

    const initialTree = rootReducer(undefined, { type: '@@INIT' })

    const program =
      preserveProgram ? (state.customer?.data?.program ?? initialTree.customer.data.program) : initialTree.customer.data.program

    const blankCustomer = clone(initialTree.customer)
    blankCustomer.data.program = program

    const blankSnap = {
      customer: blankCustomer,
      validation: clone(initialTree.validation),
      
      embedded: {
        ...initialTree.embedded,
        ...(state.embedded || {}),
        args: state.embedded?.args ?? null,
        embeddedShowNewCase: true, 
        openEmbeddedPhone: false,
      },
    }

    dispatch(hydrateSlices(blankSnap))
    await dispatch(handleNewArgs(newArgs))
    dispatch(setAppLoadingState(''));
  }


export const switchToSaleSession = (nextId) => (dispatch, getState) => {
  const state = getState()
  const curId = state.salesSessions.activeId
  const activeCaseId = state.customer.data.caseId;
  if (curId && state.salesSessions.byId[curId] && activeCaseId ) {
    const curSnap = takeSnapshot(state)  
    dispatch(saveSnapshot({ id: curId, snapshot: curSnap }))
  }

  const next = getState().salesSessions.byId[nextId]
  const snap = next?.snapshot
  if (!snap) return

  dispatch(setActiveSession(nextId))
  dispatch(hydrateSlices(snap))

  const program = snap.customer?.program ?? getState().customer?.data?.program
  const script = snap.customer?.script ?? snap.settings?.selectedNote?.script
  const mediaType = snap.customer?.mediaType

  dispatch(setNotesSection({
    script,
    mediaType,
    section: 'greetings',
    program,
  }))
  dispatch(setOrderType('new'))
  dispatch(setAppLoadingState(''))
  dispatch(setEmbeddedShowNewCase(false))
  dispatch(setIsAgentNoteOpen(true))
  
}
